__turbopack_context__.v({
  "contactCardGrid": "styles-module-scss-module__c_yaqq__contactCardGrid",
  "general": "styles-module-scss-module__c_yaqq__general",
  "getInTouchContainer": "styles-module-scss-module__c_yaqq__getInTouchContainer",
  "people": "styles-module-scss-module__c_yaqq__people",
});
